import { DefaultTheme } from 'styled-components';

import useConfiguration from './useConfiguration';

/**
 * @example const theme = useTheme();
 * @returns theme:: The complete theme object as provided to the Configuration component.
 */
const useTheme = () => useConfiguration().themeMachine.theme as DefaultTheme;

export default useTheme;
